import React, { useEffect } from 'react';
import { useState } from 'react';
import {
    Navbar,
    Container,
    Nav,
    NavDropdown,
    Button,
} from 'react-bootstrap';
import './phNavbar.css';
import { useNavigate, NavLink, useLocation } from 'react-router-dom';
import brandLogo from '../../../assets/icons/Agilisium new logo .png';
import ProcessHubLogo from '../../../assets/logo/ProcessHubWhite.png';
import { useSelector } from 'react-redux';
import HubSpoc from '../../hubspoc/HubSpoc';

function ProcessHubNavBar({ hubId }) {
    const [show, setShow] = useState(false);
    const [activeDropdown, setActiveDropdown] = useState(null);
    const navigate = useNavigate();
    const authState = useSelector((state) => state.authUser);
    const role_id = authState?.profile?.role?.role_id;
    const location = useLocation();

    const handleClose = (dropdown) => {
        setShow(false);
        setActiveDropdown(dropdown);
    };

    useEffect(() => {
        if(location.pathname === '/processHub') {
            handleClose('home')
        } else {
            return;
        }
    }, [location])
    

    return (
        <>
            <Navbar
                expand="lg"
                className="bg-body-tertiary p-0"
                expanded={show}
                style={{ position: 'fixed', width: '100%', zIndex: '999', padding: '100px !important' }}
            >
                <Container
                    fluid
                    style={{
                        background: '#FFF',
                    }}
                    className="bg-white p-1 border border-gray-400 "
                >
                    <Navbar.Brand
                        className="brand"
                        onClick={() => { navigate('/processHub'); handleClose('home') }}
                    >
                        <img
                            src={brandLogo}
                            alt="brand"
                            style={{
                                top: '19px',
                                left: '48px',
                                height: '58px',
                                opacity: '1',
                            }}
                        />
                    </Navbar.Brand>

                    <Navbar.Toggle
                        aria-controls="phNavbarScroll"
                        onClick={() => setShow(!show)}
                    />
                    <Navbar.Collapse id="phNavbarScroll">
                        <Nav
                            className="me-auto my-2 my-lg-0"
                            // style={{ maxHeight: '100px' }}
                            navbarScroll
                        >
                            <Nav.Link
                                as={NavLink}
                                to="/processHub"
                                className={`px-4 navHeader ${activeDropdown === 'home' ? 'active' : ''}`}
                                onClick={() => handleClose('home')}
                            >
                                Home
                            </Nav.Link>
                            <Nav.Link
                                as={NavLink}
                                to="/businessUnits"
                                className={`px-4 navHeader ${activeDropdown === 'departments' ? 'active' : ''}`}
                                onClick={() => handleClose('departments')}
                            >
                                Business Units
                            </Nav.Link>
                            <Nav.Link
                                as={NavLink}
                                to="/organizationChart"
                                className={`px-4 navHeader ${activeDropdown === 'organizationChart' ? 'active' : ''}`}
                                onClick={() => handleClose('organizationChart')}
                            >
                                Organization Chart
                            </Nav.Link>
                            
                            {(role_id === 6 || role_id === 1) && <NavDropdown
                                title={role_id === 6 ? "Super Admin" : "Admin"}
                                id="navbarScrollingDropdown"
                                className={`px-4 navHeader ${activeDropdown === 'admin' ? 'active' : ''}`}
                            >
                                <NavDropdown.Item
                                    as={NavLink}
                                    to="/manageDepartments"
                                    className="bg-transparent menulink"
                                    onClick={() => handleClose('admin')}
                                >
                                    Manage Business Units
                                </NavDropdown.Item>
                                <NavDropdown.Divider className='divider' />
                                <NavDropdown.Item
                                    as={NavLink}
                                    to="/manageDocuments"
                                    className="bg-transparent menulink"
                                    onClick={() => handleClose('admin')}
                                >
                                    Manage Document Details
                                </NavDropdown.Item>
                            </NavDropdown>}
                            <NavLink>
                                <HubSpoc hubId={hubId} />
                            </NavLink>
                        </Nav>
                    </Navbar.Collapse>



                    <Navbar.Brand
                        className="brand"
                        onClick={() => navigate('/')}
                    >
                        <Button className='backtohomebtn'>Go to Agilisium Page</Button>
                    </Navbar.Brand>
                </Container>
            </Navbar>
        </>
    );
}

export default ProcessHubNavBar